import React, { useEffect, useState } from "react";

export default function AddAccountsModal({ open, onClose, onAdded, taskUid = null }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) {
      setText("");
      setErr("");
      setLoading(false);
    }
  }, [open]);

  if (!open) return null;

  async function submit() {
    setErr("");
    const value = text.trim();
    if (!value) {
      setErr("Вставь хотя бы один токен (каждый с новой строки).");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch("/api/accounts/bulk", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokensText: value, taskUid }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.message || "Ошибка добавления аккаунтов");

      onAdded?.(data);
      onClose?.();
    } catch (e) {
      setErr(e.message || "Ошибка");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[999]">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={() => !loading && onClose?.()}
      />
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="w-full max-w-[640px] bg-white rounded-[18px] shadow-[0_30px_80px_rgba(0,0,0,0.25)] overflow-hidden">
          <div className="px-6 py-3 border-b border-[#E5E7EB] flex items-center justify-between">
            <div className="text-[18px] font-semibold text-[#111827]">
              Добавить аккаунты
            </div>
            <button
              type="button"
              onClick={() => !loading && onClose?.()}
              className="w-9 h-9 rounded-full bg-[#F3F4F6] hover:bg-[#EDEFF3] transition grid place-items-center"
              title="Закрыть"
            >
              ✕
            </button>
          </div>

          <div className="px-6 py-3">
            <div className="text-[13px] text-[#6B7280] mb-2">
              Каждый токен с новой строки.
            </div>

            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="w-full min-h-[180px] resize-none rounded-[12px] border border-[#E5E7EB] px-4 py-3 text-[14px] outline-none focus:border-[#2B7CFF]"
              placeholder={"vk1.a.XXXX...\nvk1.a.YYYY...\nvk1.a.ZZZZ..."}
            />

            {err && <div className="mt-3 text-[13px] text-[#B91C1C]">{err}</div>}
          </div>

          <div className="px-6 py-3 border-t border-[#E5E7EB] flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={() => !loading && onClose?.()}
              className="h-10 px-5 rounded-full bg-white border border-[#E5E7EB] text-[#111827] text-sm font-semibold hover:bg-[#F9FAFB] transition"
              disabled={loading}
            >
              Отмена
            </button>

            <button
              type="button"
              onClick={submit}
              disabled={loading}
              className="h-10 px-5 rounded-full bg-[#2B7CFF] text-white shadow-[0_12px_28px_rgba(43,124,255,0.35)] text-sm font-semibold hover:brightness-95 transition disabled:opacity-60"
            >
              {loading ? "Добавляю..." : "Добавить"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}